var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdb-streak',{attrs:{"lg":"","quote":_vm.quote,"by":_vm.by,"picture":_vm.hero_image,"overlayClass":"white-text rgba-black-light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }